import { PROVINCES } from 'store/enums';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  loader: true,
  loaderText: null,
  streetType: null,
  maritalStatus: null,
  profession: null,
  sex: null,
  signType: null,
  provinces: PROVINCES,
  theme: 'default',
  headerLogos: {
    logoFrontLeft: null,
    logoFrontRight: null
  },
  footerLogos: [],
  footerPubli: null,
  disclaimer: null,
  legal: {},
  errorPage: {
    notFound: '',
    api: ''
  },
  townsCache: {},
  validatingDocuments: false,
  continueWithSave: false,
  validateFields: false,
  support: {},
  showFilesSigId: null,
  showFilesTypeDocumentText: null,
  showFilesDocuments: null,
  checklistDocumentationAndEquip: [],
  interiorDamage: []
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
